import { useAtom } from '@reatom/npm-react'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import { Button, CloseIcon } from '@blade/ui-kit'
import { QuickBuyInput } from '@root/features/trade/quick-buy/ui'
import {
  PausedBadge,
  PlusIcon,
  WalletTrackerAlertIcon,
} from '@root/shared/ui-kit'

import { trackingWalletAlertsTableModel } from '../../atoms/reatom-tracking-wallets-alerts-table'
import { AddWalletTrackerDialog } from '../add-wallet-tracker-dialog'

import { WalletAlertsNotificationToggle } from './common/wallet-alerts-notification-toggle'
import { WalletAlertsSoundNotificationToggle } from './common/wallet-alerts-sound-notification-toggle'

type Props = {
  onClose?: () => void
}

export const WalletAlertsDialogHeader: React.FC<Props> = ({ onClose }) => {
  const { t } = useTranslation()
  const [addWalletTrackerDialogOpen, setAddWalletTrackerDialogOpen] =
    useState(false)
  const [paused] = useAtom(trackingWalletAlertsTableModel.paused)

  return (
    <Root>
      <HeaderStart>
        <Title>
          <WalletTrackerAlertIcon />
          {t('wallet-tracker.dialog.title')}
        </Title>

        {paused ? <PausedBadge paused={paused} /> : undefined}
      </HeaderStart>
      <HeaderEnd>
        <Button
          size="xs"
          variant="soft"
          radius="rounded"
          iconRight={<PlusIcon />}
          onClick={(e) => {
            e.stopPropagation()
            setAddWalletTrackerDialogOpen(true)
          }}
        />
        <WalletAlertsNotificationToggle />
        <WalletAlertsSoundNotificationToggle />
        <QuickBuyInput withUsd={false} section="walletsTracker" />
        <Button
          size="xs"
          radius="rounded"
          variant="ghost"
          iconRight={<CloseIcon />}
          onClick={onClose}
        />
      </HeaderEnd>
      <AddWalletTrackerDialog
        open={addWalletTrackerDialogOpen}
        onOpenChange={setAddWalletTrackerDialogOpen}
      />
    </Root>
  )
}

const Root = styled.div`
  display: grid;
  grid-auto-flow: column;
  align-items: center;
  justify-content: space-between;
  padding-inline: 12px;
`

const HeaderStart = styled.div`
  display: grid;
  grid-auto-flow: column;
  align-items: center;
  gap: 10px;
`

const Title = styled.div`
  display: grid;
  grid-auto-flow: column;
  align-items: center;
  gap: 4px;

  color: var(--amber-9);

  font-size: 16px;
  font-weight: 500;
  line-height: 20px;
`

const HeaderEnd = styled.div`
  display: grid;
  grid-auto-flow: column;
  align-items: center;
  gap: 8px;
  padding-block: 12px;
`
